import React from 'react';

export const CcusErrorDialog = ({ dialog }) => {
  return (
    <div className='dialog-sm-wide dialog--modal'>
      <div className='dialog-sm-wide__header'>
        <span className='dialog-sm-wide__title'>
          <span className='dialog-sm-wide__body-min'>{dialog.message}</span>
        </span>
      </div>
      <div className='dialog-sm-wide__footer'>
        <button
          className='btn--sm--sub'
          onClick={() => {
            dialog.callback.done();
          }}
        >
          了解
        </button>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/CcusErrorDialog.jsx